import { PrismaClient } from '@prisma/client';

// Avoid multiple instances of PrismaClient in dev (hot reload issue)
let prisma;

if (!global.prisma) {
  global.prisma = new PrismaClient({});
}

prisma = global.prisma;

export { prisma };

